import { lookupItemsGetId } from '../Services';
const lookupFieldsWithAnotherAPI = [
  { key : 'unit_type_unit' } ,
  { key : 'inquires_unit_type'  }

];

export const LookupsRules = (
  // item,
  // onValueOrItemChanged,
  allItems,
  allItemsValues,
  onLoadingsChanged,
  sensitiveFieldsForUser
  // loadings,
) => {
  if (!allItems || !Array.isArray(allItems)) return;
  const allItemsLocal = [...allItems];

  // const newItems = allItemsLocal.map((allItems, tabIndex) => {
  allItems.map(async (item, index) => {
    if (
      item &&
      item.data &&
      item.data.lookup &&
      //  (item.data.lookup !== '' && !(lookupFieldsWithAnotherAPI.find((f)=> f.key === (item && item.data && item.data.DtoName))))
      item.data.lookup !== '' &&  !(item.data.api && item.data.api ===  'get_values_depends_on_another_api')
      // && item.data.enum.length === 0
      // loadings.findIndex(
      //   (element) =>
      //     element.key === item.field.id && !element.result
      // && element.fromEffect !== 'fromEffect'
      // ) === -1
    ) {
      const hasEffectFromIndex = allItems.findIndex(
        (f) =>
          f.field.id.toLowerCase() ===
          (item.data.hasEffectedFrom && item.data.hasEffectedFrom.toLowerCase())
      );
      // if (hasEffectFromIndex !== -1 && !allItemsValues[allItems[hasEffectFromIndex].field.id])
      //   return;
      if(hasEffectFromIndex !== -1 )


      onLoadingsChanged(true, item.field.id);
      const result = await lookupItemsGetId({
        lookupTypeId: item.data.lookup,
        lookupParentId:
          (hasEffectFromIndex !== -1 &&
            allItemsValues[allItems[hasEffectFromIndex].field.id] &&
            allItemsValues[allItems[hasEffectFromIndex].field.id].lookupItemId) ||
          null,
      });
      if (!(result && result.status && result.status !== 200)) {
        allItemsLocal[index].data.enum = result;
        allItemsLocal[index].data.isFillData = true ;  
        if (sensitiveFieldsForUser) {
        const fieldIsSensitiveFieldsForUser = sensitiveFieldsForUser && sensitiveFieldsForUser.findIndex((s) => s.key.replace('-', '_').replace('-', '_').replace('-', '_') === (item.field.id).replace('-', '_').replace('-', '_').replace('-', '_'));
        if (fieldIsSensitiveFieldsForUser !== -1)
          allItemsLocal[index].data.isReadonly = true;
       }
      }

      // {
      // if (result.length > 0) {
      //   onValueOrItemChanged(result, undefined, 'enum', 'data');
      onLoadingsChanged(false, item.field.id);
      // } else onLoadingsChanged(false, item.field.id, []);
      // } else onLoadingsChanged(false, item.field.id, []);
    }
  });
  // return allItems[tabIndex];
  // });
  return allItemsLocal;
};
